<template>
  <div>
    <!--代辦合約-->
    <v-dialog
      v-model="agentContractDialog.visible"
      persistent
      :max-width="isMobile ? '90%':'40%'">
      <v-card>
        <v-card-title class="headline">
          {{agentContractDialog.text}}
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-layout row wrap>
            <v-flex>
              <v-text-field v-model="agentContractDialog.vendorName"
                            :placeholder="`請輸入代辦名稱`"
                            :label="`代辦名稱`" ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex>
              <v-text-field v-model="agentContractDialog.username"
                  :placeholder="`請輸入委託人名稱`"
                  :label="`委託人名稱`" ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex>
              <v-text-field v-model="agentContractDialog.memberId"
                            :placeholder="`請輸入委託人身分證`"
                            :label="`委託人身分證`" ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex>
              <v-text-field v-model="agentContractDialog.cellphone"
                  :placeholder="`請輸入委託人電話`"
                  :label="`委託人電話`" ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex>
              <v-text-field v-model="agentContractDialog.address"
                  :placeholder="`請輸入委託人地址`"
                  :label="`委託人地址`" ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex>
              <v-text-field v-model="agentContractDialog.bonus"
                  :placeholder="`佣金(%)`"
                  :label="`佣金(%)`" ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row wrap v-if="agentContractDialog.showAuto">
            <v-flex>
              <v-checkbox
                v-model="agentContractDialog.auto"
                label="是否要自動帶入案件資料？"
              ></v-checkbox>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex>
              <v-checkbox
                v-model="link"
                label="建立分享連結？"
              ></v-checkbox>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn dark text color="success" @click="show">查看</v-btn>
          <v-btn dark text @click="agentContractDialog.cancel">取消</v-btn>
          <v-btn class="primary" dark text :loading="saveLoading"
                               @click="save">列印</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!--提示-->
    <alert-view :visible="messageDialog.visible"
                  :title="messageDialog.title"
                  :content="messageDialog.text"
                  :show-cancel="false"
                  @confirmEvent="messageDialog.confirm">
                </alert-view>
  </div>
</template>

<script>
  import MobileDetect from 'mobile-detect';
  const md = new MobileDetect(window.navigator.userAgent);
  import { mapActions, mapGetters } from 'vuex';
  import AlertView from '../components/AlertView'

  export default {
    name: 'AgentContractView',
    props:{
      agentContractDialog: Object,
    },
    components: {AlertView},
    data(){
      return {
        isMobile: md.phone(),
        saveLoading: false,
        link: false,
        messageDialog: {
          title: '',
          text: '',
          visible: false,
          showCancel: false,
          confirm: () => {
          },
          cancel: () => {
          },
        },
      }
    },
    methods: {
      ...mapActions(['saveContractInfo']),
      async save(){
        const caseData = {
          caseId: this.agentContractDialog.caseId,
          vendor: this.agentContractDialog.vendorName,
          username: this.agentContractDialog.memberName,
          address: this.agentContractDialog.address,
          cellphone: this.agentContractDialog.cellphone,
          memberId: this.agentContractDialog.memberId,
          bonus: this.agentContractDialog.bonus,
        };

        this.saveLoading = true;
        const res = await this.saveContractInfo(caseData);
        this.saveLoading = false;
        if (res){
          const result = res.data;
          if (result.statusCode === 0){
            this.$emit('saveContract', result.data);
            this.showMessageDialog('成功','儲存成功', true, ()=>{},()=>{});
          } else {
            this.showMessageDialog('錯誤', result.message, true, ()=>{},()=>{});
          }
        } else {
          this.showMessageDialog('錯誤', '發生錯誤', true, ()=>{},()=>{});
        }
      },
      show(){
        let routeData = this.$router.resolve({
          path: '/AgentContract', query: {
            contractId: this.agentContractDialog.caseId,
          }
        });
        window.open(routeData.href, '_blank');
      },
      showMessageDialog(title, text, visible, confirmEvent, cancelEvent) {
        this.messageDialog.title = title;
        this.messageDialog.text = text;
        this.messageDialog.visible = visible;
        const self = this;
        this.messageDialog.confirm = () => {
          self.messageDialog.visible = false;
          if (confirmEvent) {
            confirmEvent();
          }
        };

        this.messageDialog.cancel = () => {
          self.messageDialog.visible = false;
          if (cancelEvent) {
            cancelEvent();
          }
        };
      },

    }
  };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/AgentContractView.vue